import { render, staticRenderFns } from "./ActivityAliveBadge.vue?vue&type=template&id=05191fbe&scoped=true&"
import script from "./ActivityAliveBadge.vue?vue&type=script&lang=js&"
export * from "./ActivityAliveBadge.vue?vue&type=script&lang=js&"
import style0 from "./ActivityAliveBadge.vue?vue&type=style&index=0&id=05191fbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05191fbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05191fbe')) {
      api.createRecord('05191fbe', component.options)
    } else {
      api.reload('05191fbe', component.options)
    }
    module.hot.accept("./ActivityAliveBadge.vue?vue&type=template&id=05191fbe&scoped=true&", function () {
      api.rerender('05191fbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/kanban/components/ActivityAliveBadge.vue"
export default component.exports